import styled, { css } from 'styled-components';
import { Icon } from '../Icon';

const ICON_WIDTH = 16;

export const inputReadOnlyMixin = css`
  background-color: ${(props) => props.theme.colors.lightGray};
  border: solid 1px ${(props) => props.theme.colors.defaultContentBorder};
  color: ${(props) => props.theme.colors.contentPlaceholder};
  outline-style: none;
  box-shadow: none;
`;

export const inputColorMixin = css<IInputStyled>`
  background-color: ${(props) => props.theme.colors.defaultContentBackground};
  border: solid 1px
    ${(props) => (props.showErrorHighlight ? props.theme.colors.error : props.theme.colors.secondarySelectedBackground)};
`;

export const hoverInputStyle = css<IInputStyled>`
  background: ${(props) => props.theme.colors.gray50};
  border: 1px solid
    ${(props) =>
      props.showErrorHighlight ? props.theme.colors.errorBorder : props.theme.colors.secondarySelectedBackground};
  box-shadow: 0px 1px 2px ${(props) => props.theme.colors.focusHoverShadow};
  border-radius: 6px;
`;

export const disabledInputStyle = css`
  border-color: ${(props) => props.theme.colors.lightGray};
  border: 1px solid ${(props) => props.theme.colors.lightGray};
  color: lighten(${(props) => props.theme.colors.defaultContentText}, 25%);
  background: ${(props) => props.theme.colors.lightGray};
  box-shadow: unset;

  &:hover {
    border-color: ${(props) => props.theme.colors.lightGray};
    border: 1px solid ${(props) => props.theme.colors.lightGray};
    color: lighten(${(props) => props.theme.colors.defaultContentText}, 25%);
    background: ${(props) => props.theme.colors.lightGray};
    box-shadow: unset;
  }
`;

export interface IInputStyled {
  showErrorHighlight?: boolean;
  hasPrependIcon?: boolean;
  hasAppendIcon?: boolean;
}

//theme 1
export const InputCss = css<IInputStyled>`
  box-sizing: border-box;
  ${(props) => props.theme.fonts.smallSize};
  ${(props) => props.theme.fonts.header5LineHeight};
  ${inputColorMixin};
  border-radius: 6px;
  color: ${(props) =>
    props.showErrorHighlight ? props.theme.colors.errorText : props.theme.colors.defaultContentText};
  outline: none;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: ${(props) => `${13 + (props.hasPrependIcon ? ICON_WIDTH : 0)}px`};
  padding-right: ${(props) => `${13 + (props.hasAppendIcon ? ICON_WIDTH : 0)}px`};
  width: 100%;

  &::placeholder {
    color: ${(props) => props.theme.colors.contentPlaceholder};
  }

  &:disabled {
    ${disabledInputStyle};
  }

  &:hover {
    ${hoverInputStyle};
  }

  &:focus {
    background: ${(props) => props.theme.colors.defaultContentBackground};
    border-color: ${(props) => (props.showErrorHighlight ? props.theme.colors.error : props.theme.colors.primary)};
    box-shadow:
      0px 1px 2px ${(props) => props.theme.colors.focusHoverShadow},
      0px 0px 0px 1px
        ${(props) => (props.showErrorHighlight ? props.theme.colors.errorBorder : props.theme.colors.primary)};
  }

  &:read-only:not(div) {
    ${inputReadOnlyMixin}
  }
`;

export const InputStyled = styled.input<IInputStyled>`
  ${InputCss};
`;

export const InputIconStyled = styled(Icon)<{ anchor: 'left' | 'right' }>`
  ${(props) =>
    props.anchor === 'right' ? `right: ${props.theme.spacing.spacing4};` : `left: ${props.theme.spacing.spacing4};`};
  height: ${ICON_WIDTH}px;
  pointer-events: none;
  position: absolute;
  top: ${(props) => props.theme.spacing.spacing4};
  width: ${ICON_WIDTH}px;
`;
